import {
  NOTIFICATION_LIST_REQUEST,
  NOTIFICATION_LIST_SUCCESS,
  NOTIFICATION_LIST_ERROR,
  NOTIFICATION_LIST_SET,
  ALERT_LIST_REQUEST,
  ALERT_LIST_REQUEST_PAUSE,
  NOTIFICATION_READ_REQUEST,
  NOTIFICATION_READ_SUCCESS,
  NOTIFICATION_READ_ERROR,
  NOTIFICATION_CLEAR_REQUEST,
  NOTIFICATION_CLEAR_SUCCESS,
  NOTIFICATION_CLEAR_ERROR,
  NOTIFICATION_CLEARALL_REQUEST,
  NOTIFICATION_CLEARALL_SUCCESS,
  NOTIFICATION_CLEARALL_ERROR
} from './notifications.type'
import moment from 'moment-timezone'
import ApiRest from '@/api/api-rest'

import IQCollection from '@/resources/collections/IQCollection'
import { NotificationTypeEnum } from '@/constants/notification.constants'
import {
  TrailNotification,
  HostNotification,
  AssignmentNotification
} from '@/resources/models/notification'

const state = {
  notificationsReqStatus: '',
  notificationList: JSON.parse(localStorage.getItem('user_profile')) || {},
  pauseNotificationAlerts: false
}

const getters = {
  notificationsReqStatus: state => state.notificationsReqStatus,
  notificationList: state => state.notificationList,
  pauseNotificationAlerts: state => state.pauseNotificationAlerts
}

// Best Practice - updates state
const mutations = {
  [NOTIFICATION_LIST_REQUEST]: state =>
    (state.notificationsReqStatus = 'loading'),
  [NOTIFICATION_LIST_SUCCESS]: state =>
    (state.notificationsReqStatus = 'saved'),
  [NOTIFICATION_LIST_ERROR]: (state, errMsg) => {
    state.notificationsReqStatus = 'error'
  },
  [NOTIFICATION_LIST_SET]: (state, notifications) => {
    state.notificationList = notifications
  },
  [ALERT_LIST_REQUEST]: state => {},
  [ALERT_LIST_REQUEST_PAUSE]: (state, toPause) => {
    state.pauseNotificationAlerts = toPause
  },
  [NOTIFICATION_READ_REQUEST]: state => {},
  [NOTIFICATION_READ_SUCCESS]: state => {},
  [NOTIFICATION_READ_ERROR]: (state, errMsg) => {},
  [NOTIFICATION_CLEAR_REQUEST]: state => {},
  [NOTIFICATION_CLEAR_SUCCESS]: state => {},
  [NOTIFICATION_CLEAR_ERROR]: (state, errMsg) => {},
  [NOTIFICATION_CLEARALL_REQUEST]: state => {},
  [NOTIFICATION_CLEARALL_SUCCESS]: state => {},
  [NOTIFICATION_CLEARALL_ERROR]: (state, errMsg) => {}
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [NOTIFICATION_LIST_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(NOTIFICATION_LIST_REQUEST)
      ApiRest()
        .get('/notifications')
        .then(({ data }) => {
          // Use desc sort, show latest first
          data = _.chain(data)
            .map(notification => {
              switch (notification.event_type) {
                case NotificationTypeEnum.HOST:
                  return new HostNotification('id', notification)
                case NotificationTypeEnum.ASSIGNMENT:
                  return new AssignmentNotification('id', notification)
                default:
                  return new TrailNotification('id', notification)
              }
            })
            .sort((a, b) => {
              return moment(b.details.createdOn) - moment(a.details.createdOn)
            })
            .value()

          data = new IQCollection(data)

          context.commit(NOTIFICATION_LIST_SUCCESS)
          context.commit(NOTIFICATION_LIST_SET, data)

          resolve(data)
        })
        .catch(errMsg => {
          context.commit(NOTIFICATION_LIST_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [ALERT_LIST_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      // pause polling
      if (context.getters['pauseNotificationAlerts']) {
        resolve({})
      }
      context.commit(ALERT_LIST_REQUEST)
      ApiRest()
        .get(`/notifications?createdOn=${payload.createdOn}`)
        // .get(`/notifications/poll`)
        .then(({ data }) => {
          // asc sort, $alert will treat as queue (first item should be last)
          data = _.chain(data)
            .map(notification => {
              switch (notification.event_type) {
                case NotificationTypeEnum.HOST:
                  return new HostNotification('id', notification)
                case NotificationTypeEnum.ASSIGNMENT:
                  return new AssignmentNotification('id', notification)
                default:
                  return new TrailNotification('id', notification)
              }
            })
            .sort((a, b) => {
              return moment(a.details.createdOn) - moment(b.details.createdOn)
            })
            .value()
          resolve(data)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [ALERT_LIST_REQUEST_PAUSE] (context, toPause) {
    context.commit(ALERT_LIST_REQUEST_PAUSE, toPause)
  },
  [NOTIFICATION_READ_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(NOTIFICATION_READ_REQUEST)
      ApiRest()
        .put(`/notifications/read/${payload.id}`)
        .then(({ data }) => {
          context.commit(NOTIFICATION_READ_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(NOTIFICATION_READ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [NOTIFICATION_CLEAR_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(NOTIFICATION_CLEAR_REQUEST)
      ApiRest()
        .put(`/notifications/clear/${payload.id}`)
        .then(({ data }) => {
          context.commit(NOTIFICATION_CLEAR_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(NOTIFICATION_CLEAR_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [NOTIFICATION_CLEARALL_REQUEST] (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit(NOTIFICATION_CLEARALL_REQUEST)
      ApiRest()
        .post(`/notifications/clearall`)
        .then(({ data }) => {
          context.commit(NOTIFICATION_CLEARALL_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(NOTIFICATION_CLEARALL_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications/notifications.module.js